var angular=window.angular,ngModule;
try {ngModule=angular.module(["ikeweb.templates"])}
catch(e){ngModule=angular.module("ikeweb.templates",[])}
var v1="<div class=\"UserLocaleChooserSmall\">\n<i class=\"UserLocaleChooserSmall-icon\" ng-click=\"toggleDropdown($event)\"></i>\n<ul class=\"UserLocaleChooserSmall-dropdownList ng-hide\" ng-show=\"showDropdown\">\n<li class=\"UserLocaleChooserSmall-dropdownListItem\" ng-repeat=\"locale in ctrl.getAvailableLocales()\">\n<a class=\"UserLocaleChooserSmall-dropdownListItemLink\" ng-class=\"{'UserLocaleChooserSmall-dropdownListItemLink-selected' : ctrl.isCurrent(locale.value)}\" ng-click=\"ctrl.setCurrentLocale(locale.value)\">\n{{ locale.label }}\n</a>\n</li>\n</ul>\n</div>";
var id1="chooser.small.html";
var inj=angular.element(window.document).injector();
if(inj){inj.get("$templateCache").put(id1,v1);}
else{ngModule.run(["$templateCache",function(c){c.put(id1,v1)}]);}
module.exports=id1;


//////////////////
// WEBPACK FOOTER
// ./src/client/components/locale/chooser-small/chooser.small.html
// module id = 508
// module chunks = 0